import katex from 'katex';
import 'katex/mhchem';
import 'br-katex-macros';
import 'br-katex-siunitx';
import katexOpts from 'br-katex-options';
import latexregex from 'br-katex-latexregex';
import 'katex/dist/katex.min.css';

// TODO: Try shadowdom
// TODO: use shared backing stylesheet: (see Internal vs. External styles)
// TODO: Merge this with interactives/shared/katex.ts. The only place they differ is in the error handling.

export default function setupKatexElement() {
  if (customElements.get('katex-element')) {
    return;
  }
  customElements.define(
    'katex-element',
    class KatexElement extends HTMLElement {
      latexValue: string;
      constructor() {
        super();
        this.latexValue = '';
      }

      connectedCallback() {
        this.renderMath();
      }

      get latex() {
        return this.latexValue;
      }

      set latex(value: string) {
        this.latexValue = latexregex.replace(value);
        this.renderMath();
      }

      static get observedAttributes() {
        return ['displayMode'];
      }

      attributeChangedCallback(): void {
        this.renderMath();
      }

      renderMath(): void {
        try {
          const options =
            this.getAttribute('displayMode') === 'block' ? katexOpts.block : katexOpts.inline;
          katex.render(this.latexValue, this, options);
        } catch (e) {
          // tslint:disable-next-line:no-console
          console.error(e);
          this.innerHTML = `<span style="color:tomato" title="${e.message}">[math error]</span>`;
        }
      }
    },
  );
}
